import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

const apiUrl = 'https://cfmart-backend.onrender.com';

const Section1099 = ({ currentUser }) => {
  const history = useHistory();

  const [payload, setPayload] = React.useState(null);
  const [formRequestResponse, setFormRequestResponse] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [hasFetched, setHasFetched] = React.useState(false);

  const spinnerStyle = {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    border: '3px solid rgba(0,0,0,0.1)',
    borderTop: '3px solid #000',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginRight: '0.5rem',
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  };

  const Spinner = () => (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <span style={spinnerStyle}></span>
      Processing...
    </span>
  );

  if (!currentUser?.id) {
    return (
      <div className="seller_signup">
        <div className="container">
          <h1>ACCESS DENIED</h1>
          <p>You must be logged in to access this page.</p>
          <a href="/login" className="cta btn-cta">
            Login
          </a>
        </div>
      </div>
    );
  }

  const triggerUserStatusUpdate = () => {
    fetch(`${apiUrl}/api/update-user-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: currentUser.id.uuid,
        email: currentUser.attributes?.email,
      }),
    })
      .then(res => res.json())
      .then(updateResponse => {
        console.log('✅ User status updated:', updateResponse);

        return fetch(`${apiUrl}/api/klaviyo/add-user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: currentUser.attributes?.email,
          }),
        });
      })
      .then(res => res.json())
      .then(klaviyoResponse => {
        console.log('✅ Klaviyo update response:', klaviyoResponse);
        setTimeout(() => {
          setIsLoading(false);
          history.push(
            '/l/draft/00000000-0000-0000-0000-000000000000/new/details'
          );
        }, 2000);
      })
      .catch(err => {
        console.error('❌ Post-signature updates failed:', err);
        setIsLoading(false);
      });
  };

  const handleW9Completion = () => {
    console.log('✅ W9 completion detected, triggering user status update...');
    setIsLoading(true);
    triggerUserStatusUpdate();
  };

  const handleW9Request = () => {
    const userId = currentUser?.id?.uuid;
    if (!userId) return;

    setIsLoading(true);

    const data = {
      data: {
        type: 'form_request',
        attributes: {
          form_type: 'W-9',
          company_id: 528340243,
          reference_id: userId,
          ttl: 3600,
        },
      },
    };

    fetch(`${apiUrl}/api/generate-w9`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(res => res.json())
      .then(json => {
        const responseData = {
          form_request_id: json.form_request_id,
          signed_at: json.signed_at,
          form_type: json.form_type,
          company_id: json.company_id,
          reference_id: json.reference_id,
          raw: json.raw,
        };

        setFormRequestResponse(responseData);
        setHasFetched(true);

        // Legacy check: call handleW9Completion if signed_at is present
        if (json?.signed_at) {
          console.log('✅ Already signed at generation time, proceeding...');
          handleW9Completion();
        } else if (json.form_request_id) {
          setIsLoading(false);
        }
      })
      .catch(err => {
        console.error('❌ Track1099 API error:', err);
        setIsLoading(false);
      });
  };

  React.useEffect(() => {
    if (
      !formRequestResponse?.form_request_id ||
      formRequestResponse?.signed_at ||
      !hasFetched
    )
      return;

    console.log(
      '🟡 Embed trigger: rendering ID:',
      formRequestResponse.form_request_id
    );

    const container = document.getElementById('form_request_embed_container');
    if (!container) {
      console.warn('❌ Embed container not found');
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://www.track1099.com/api/request_form.js';
    script.type = 'module';
    script.crossOrigin = 'anonymous';

    script.onload = () => {
      console.log('✅ Track1099 script loaded');
      if (window.Avalara1099?.requestW9) {
        console.log(
          '📥 Calling Avalara1099.requestW9 with:',
          formRequestResponse.raw
        );
        window.Avalara1099.requestW9(formRequestResponse.raw);
      } else {
        console.warn('⚠️ Avalara1099.requestW9 not available');
      }
    };

    const isDev = window.location.hostname === 'localhost';
    const allowedOrigin = isDev ? '*' : 'https://www.track1099.com';

    const handleMessage = event => {
      if (isDev || event.origin === allowedOrigin) {
        /* if (event.data?.event === 'complete') {
          handleW9Completion();
        } */
        if (
          event.data?.name === 'complete' &&
          event.data?.data.attributes.signed_at
        ) {
          handleW9Completion();
        }
      }
    };
    window.addEventListener('message', handleMessage);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      window.removeEventListener('message', handleMessage);
    };
  }, [formRequestResponse, hasFetched]);

  return (
    <div className="seller_signup">
      {isLoading && (
        <div style={overlayStyle}>
          <Spinner />
        </div>
      )}
      <div className="container">
        <h1>READY TO POST WORK?</h1>
        <p>
          <b>PLEASE FILL OUT THE W9 FORM BELOW</b>
        </p>

        {!formRequestResponse?.signed_at && (
          <a
            href="#"
            className="cta"
            onClick={e => {
              e.preventDefault(); // ✅ prevent jumping to "#"
              handleW9Request(); // ✅ run your handler
            }}
          >
            FILL OUT W9
          </a>
        )}
        {formRequestResponse?.signed_at && !isLoading && (
          <p style={{ marginTop: '1rem', fontWeight: 'bold', color: 'green' }}>
            ✅ W-9 already signed on{' '}
            {new Date(formRequestResponse.signed_at).toLocaleString()}
          </p>
        )}

        {formRequestResponse?.signed_at && isLoading && (
          <p style={{ marginTop: '1rem', fontWeight: 'bold', color: '#555' }}>
            <Spinner />
          </p>
        )}
        {hasFetched &&
          !formRequestResponse?.signed_at &&
          formRequestResponse?.form_request_id && (
            <div style={{ marginTop: '2rem' }}>
              <div
                id="form_request_embed_container"
                data-form-request-id={formRequestResponse.form_request_id}
              ></div>
            </div>
          )}
        <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">
          Review Terms of Service
        </a>
      </div>
    </div>
  );
};

export default connect(state => ({
  currentUser: state.user?.currentUser,
}))(Section1099);
